import React from 'react';

/**
 * ============================================
 * Header Component - Modatex Style
 * ============================================
 * Minimal navigation bar matching Home page
 */

const Header = ({ searchTerm, onSearchChange }) => {
    return (
        <nav className="fixed top-0 left-0 right-0 z-[9999] bg-white/95 backdrop-blur-sm pointer-events-auto border-b border-gray-200">
            <div className="max-w-[1800px] mx-auto px-6 lg:px-12">
                <div className="flex items-center justify-between h-20">
                    {/* Logo */}
                    <a href="/" className="flex items-center space-x-2">
                        <span className="text-2xl font-serif font-bold text-[#3D3D3D]">Modatex</span>
                    </a>

                    {/* Right side - Search only */}
                    <div className="flex items-center space-x-6">
                        <div className="relative">
                            <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                            </svg>
                            <input
                                type="text"
                                placeholder="Rechercher"
                                value={searchTerm}
                                onChange={(e) => onSearchChange(e.target.value)}
                                className="pl-10 pr-4 py-2 bg-gray-50 border border-gray-300 rounded-full text-[#3D3D3D] placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-[#3D3D3D] focus:border-transparent transition-all text-sm w-64"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </nav>
    );
};

export default Header;
